import { Modal } from 'antd'
import { useState } from 'react'
import { LoaderCircle } from 'lucide-react'

import DocFileSvg from '@/assets/images/file/file-doc.svg'
import DocxFileSvg from '@/assets/images/file/file-docx.svg'
import PdfFileSvg from '@/assets/images/file/file-pdf.svg'
import TxtFileSvg from '@/assets/images/file/file-txt.svg'
import MdFileSvg from '@/assets/images/file/file-md.svg'
import { convertSize } from '@/utils/formate'
import DocViewer from '@/components/DocViewer'

const fileIconMap = {
  doc: DocFileSvg,
  docx: DocxFileSvg,
  pdf: PdfFileSvg,
  txt: TxtFileSvg,
  md: MdFileSvg,
}

export const DocFileIcon = ({
  fileExtension,
}: {
  fileExtension: keyof typeof fileIconMap
}) => {
  return (
    <img
      className="w-[60px] h-[60px] flex-shrink-0"
      src={fileIconMap[fileExtension]}
    />
  )
}

export const ChatFileItem = ({ doc, preview = false, className }: any) => {
  const [open, setOpen] = useState(false)
  const fileExtension = doc?.filename?.split('.').pop() || ''
  const fileSize = convertSize(doc?.filesize)
  if (JSON.stringify(doc) === '{}') return null

  return (
    <div
      className={`relative flex w-60 rounded-xl p-2 bg-gradient-to-b from-[#FFFFFF] to-[#EEF7FF] border border-[#1C1F230F] ${className}`}
    >
      <div
        className="w-full flex items-center gap-2"
        onClick={() => {
          preview && setOpen(true)
        }}
      >
        <DocFileIcon fileExtension={fileExtension} />
        <div className="min-w-0 flex-1 py-2 text-sm flex flex-col">
          <div className="text-ellipsis overflow-hidden text-nowrap w-full">
            {doc.filename}
          </div>

          {doc.fileurl ? (
            <span className="text-xs flex gap-2 text-[#6D728D]">
              <span>{fileExtension}</span>
              <span>{fileSize}</span>
            </span>
          ) : (
            <span className="text-xs flex items-center gap-2 text-[#6D728D]">
              <LoaderCircle size={14} className="animate-spin mr-1" />
              <span>上传中...</span>
            </span>
          )}
        </div>
      </div>
      <Modal
        className="max-w-3xl min-w-72"
        destroyOnClose={true}
        width="80%"
        open={open}
        title={doc.filename}
        onCancel={() => {
          console.log('Cancel')
          setOpen(false)
        }}
        footer={null}
      >
        <div className="min-h-[300px] h-[70vh] overflow-auto">
          <DocViewer src={doc.fileurl} />
        </div>
      </Modal>
    </div>
  )
}
